export const USER_LANGUAGE = {
    SPANISH: 'es',
    ENGLISH: 'en',
} as const;

export type UserLanguage = typeof USER_LANGUAGE[keyof typeof USER_LANGUAGE];

export const USER_LANGUAGE_STORAGE_KEY = 'language';

export const USER_API_ROUTES = {
    CURRENT: '/auth/me',
} as const;
